import Icon from 'components/Icon'
import GymaholicLogo from 'components/Icon/icons/gymaholic'
import React from 'react'

function Logo () {
  return (
    <div
      style={{
        display: 'flex',
        margin: '0'
      }}
    >
      <GymaholicLogo />
    </div>
  )
}

Logo.propTypes = {
  size: Icon.propTypes.size
}
Logo.defaultProps = {
  size: Icon.SIZE.BIGGEST
}
Logo.SIZE = Icon.SIZE
export default Logo
